import React, { PropTypes } from 'react';
//import Hus from 'components/Special/Hus/Hus';
//import Flygplats from 'components/Special/Flygplats/Flygplats';
//import Header from 'components/Special/Header/Header';
//import Avdelare from 'components/Special/Avdelare/Avdelare';
//import Kartbox from 'components/Special/Kartbox/Kartbox';
//import Gif from 'components/Special/Gif/Gif';
//import Utslapp from 'components/Special/utslapp/utslapp';

const SpecialComponent = ({ component, value }) => {
  switch (component.toLowerCase()) {
    //case 'avdelare':
    //  return <Avdelare value={value}/>;
    //case 'kartbox':
    //  return <Kartbox value={value}/>;
    //case 'gif':
    //  return <Gif/>;
    //case 'utslapp':
    //  return <Utslapp/>;
    //case 'hus':
    //  return <Hus/>;
    //case 'flygplats':
    //  return <Flygplats/>;
    //case 'header':
    //  return <Header/>;
    default:
      return <div style={{color: 'red', fontSize:'24px'}}>Special: {component}, value:{JSON.stringify(value)}</div>;
  }
};

SpecialComponent.propTypes = {
  component: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ])
};
export default SpecialComponent;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/Page/PageComponents/Special/_SpecialComponent.js
 **/